import { ValidationErrorData } from '../typings/common';

export const OPEN_ADD_CHAT_LIST_MODAL = 'OPEN_ADD_CHAT_LIST_MODAL';
export type OPEN_ADD_CHAT_LIST_MODAL = typeof OPEN_ADD_CHAT_LIST_MODAL;

export interface OpenAddChatListModalAction {
    type: OPEN_ADD_CHAT_LIST_MODAL;
}

export function openAddChatListModal(): OpenAddChatListModalAction {
    return {
        type: OPEN_ADD_CHAT_LIST_MODAL
    };
}

export const CLOSE_ADD_CHAT_LIST_MODAL = 'CLOSE_ADD_CHAT_LIST_MODAL';
export type CLOSE_ADD_CHAT_LIST_MODAL = typeof CLOSE_ADD_CHAT_LIST_MODAL;

export interface CloseAddChatListModalAction {
    type: CLOSE_ADD_CHAT_LIST_MODAL;
}

export function closeAddChatListModal(): CloseAddChatListModalAction {
    return {
        type: CLOSE_ADD_CHAT_LIST_MODAL
    };
}

export const SAVE_ADD_CHAT_LIST_MODAL = 'SAVE_ADD_CHAT_LIST_MODAL';
export type SAVE_ADD_CHAT_LIST_MODAL = typeof SAVE_ADD_CHAT_LIST_MODAL;

export interface SaveAddChatListModalAction {
    type: SAVE_ADD_CHAT_LIST_MODAL;
}

export function saveAddChatListModal(): SaveAddChatListModalAction {
    return {
        type: SAVE_ADD_CHAT_LIST_MODAL
    };
}

export const INPUT_CHANGE_ADD_CHAT_LIST_MODAL = 'INPUT_CHANGE_ADD_CHAT_LIST_MODAL';
export type INPUT_CHANGE_ADD_CHAT_LIST_MODAL = typeof INPUT_CHANGE_ADD_CHAT_LIST_MODAL;

export interface InputChangeAddChatListModalAction {
    type: INPUT_CHANGE_ADD_CHAT_LIST_MODAL;
    id: string;
}

export function inputChangeAddChatListModal(id: string): InputChangeAddChatListModalAction {
    return {
        type: INPUT_CHANGE_ADD_CHAT_LIST_MODAL,
        id
    };
}

export const SHOW_ERROR_ADD_CHAT_LIST_MODAL = 'SHOW_ERROR_ADD_CHAT_LIST_MODAL';
export type SHOW_ERROR_ADD_CHAT_LIST_MODAL = typeof SHOW_ERROR_ADD_CHAT_LIST_MODAL;

export interface ShowErrorAddChatListModalAction {
    type: SHOW_ERROR_ADD_CHAT_LIST_MODAL;
    errors: Array<ValidationErrorData>;
}

export function showErrorAddChatListModal(errors: Array<ValidationErrorData>): ShowErrorAddChatListModalAction {
    return {
        type: SHOW_ERROR_ADD_CHAT_LIST_MODAL,
        errors
    };
}

export type AddChatListEditorAction =
    | OpenAddChatListModalAction
    | CloseAddChatListModalAction
    | SaveAddChatListModalAction
    | InputChangeAddChatListModalAction
    | ShowErrorAddChatListModalAction;
